import { render, staticRenderFns } from "./EightHolterReport.vue?vue&type=template&id=3ba7d28c&scoped=true"
import script from "./EightHolterReport.vue?vue&type=script&lang=js"
export * from "./EightHolterReport.vue?vue&type=script&lang=js"
import style0 from "./EightHolterReport.vue?vue&type=style&index=0&id=3ba7d28c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba7d28c",
  null
  
)

export default component.exports